<template>
  <div>
    <img src="@/assets/images/No-data.svg" alt="" class="w-2/5 m-auto" />
    <p class="font-semibold text-center text-xl">{{ title }}</p>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "There are currently no items",
    },
  },
};
</script>
